import { createAction } from 'Helpers';
import locationTypes from './types';

const locationActions = {
	locationsListRequest: createAction(locationTypes.LIST.REQUEST),
	locationsListSuccess: createAction(locationTypes.LIST.SUCCESS),
	locationsListFailure: createAction(locationTypes.LIST.FAILURE),
	clearLocationsList: createAction(locationTypes.LIST.CLEAR),
	neshanPositionRequest: createAction(locationTypes.NESHAN_POSITION.REQUEST),
	neshanPositionSuccess: createAction(locationTypes.NESHAN_POSITION.SUCCESS),
	neshanPositionFailure: createAction(locationTypes.NESHAN_POSITION.FAILURE),
	clearNeshanPosition: createAction(locationTypes.NESHAN_POSITION.CLEAR),

	pointToAddressRequest: createAction(locationTypes.POINT_TO_ADDRESS.REQUEST),
	pointToAddressSuccess: createAction(locationTypes.POINT_TO_ADDRESS.SUCCESS),
	pointToAddressFailure: createAction(locationTypes.POINT_TO_ADDRESS.FAILURE),
	clearPointToAddress: createAction(locationTypes.POINT_TO_ADDRESS.CLEAR),

	pointToLocationRequest: createAction(locationTypes.POINT_TO_LOCATION.REQUEST),
	pointToLocationSuccess: createAction(locationTypes.POINT_TO_LOCATION.SUCCESS),
	pointToLocationFailure: createAction(locationTypes.POINT_TO_LOCATION.FAILURE),
	clearPointToLocation: createAction(locationTypes.POINT_TO_LOCATION.CLEAR),

	locationGeneralRequest: createAction(locationTypes.LOCATION_GENERAL.REQUEST),
	locationGeneralFailure: createAction(locationTypes.LOCATION_GENERAL.FAILURE),
	locationGeneralReset: createAction(locationTypes.LOCATION_GENERAL.RESET),

	locationProvinceSuccess: createAction(
		locationTypes.LOCATION_PROVINCE.SUCCESS
	),
	clearLocationProvince: createAction(locationTypes.LOCATION_PROVINCE.CLEAR),

	locationCitySuccess: createAction(locationTypes.LOCATION_CITY.SUCCESS),
	clearLocationCity: createAction(locationTypes.LOCATION_CITY.CLEAR),

	locationDistrictSuccess: createAction(
		locationTypes.LOCATION_DISTRICT.SUCCESS
	),
	clearLocationDistrict: createAction(locationTypes.LOCATION_DISTRICT.CLEAR),

	locationAreaSuccess: createAction(locationTypes.LOCATION_AREA.SUCCESS),
	clearLocationArea: createAction(locationTypes.LOCATION_AREA.CLEAR),
};

export default locationActions;
